import Vue from 'vue'
import CryptoJS from 'crypto-js'
import moment from 'moment'

export default {
  setFromResponse (response, rememberMe) {
    const expired = moment().add(response.expires_in, 'seconds').format()
    this.set(response.access_token, expired, rememberMe)
  },
  set: function (token, expired, rememberMe) {
    const encryptedToken = CryptoJS.AES.encrypt(token, 'nativehash').toString()

    let expires = '1h'
    if (rememberMe || Vue.cookie.get('remember-me')) {
      expires = '24D'
      Vue.cookie.set('remember-me', 1, { expires: expires, SameSite: 'Lax' })
    }

    const value = JSON.stringify({
      token: encryptedToken,
      expired: expired
    })

    Vue.cookie.set('token', value, { expires: expires, SameSite: 'Strict', Secure: true })
  },
  get: function () {
    const cookie = JSON.parse(Vue.cookie.get('token'))
    if (cookie && cookie.token) {
      const bytes = CryptoJS.AES.decrypt(cookie.token, 'nativehash')
      cookie.token = bytes.toString(CryptoJS.enc.Utf8)

      return cookie
    } else {
      return false
    }
  },
  exists: function () {
    return Vue.cookie.get('token') && true
  },
  isCorrect: function () {
    const cookie = this.get()
    if (!cookie) {
      return false
    }
    /* add some time for smoother refresh */
    return moment(cookie.expired) > moment().add(2, 'minutes')
  },
  remove: function () {
    Vue.cookie.delete('token')
    Vue.cookie.delete('remember-me')
  }
}
